/*! tooltips.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
(function Tooltips(SD) {
  "use strict";

  var support = getSupport();
  var instances = nodeList("[data-tooltips-config]");

  instances.map(function (instance) {
    var config = Object.freeze(getConfig(instance));

    var publicAPI = {
      tooltips: function () {
        return getTooltips(config);
      },
      tooltip: getTooltip,
      select: select,
      deselect: deselect,
      config: config,
      init: init,
    };

    if (!SD[config.sectionId]) init(config);
    SD[config.sectionId] = publicAPI;

    return publicAPI;
  });

  // ******************************

  function init(config) {
    var tooltips = getTooltips(config);
    var triggers = pluck(tooltips, "trigger");

    triggers.map(function (element) {
      element.addEventListener("click", function triggerClick() {
        tooltipClick(tooltips, element.value);
      });
    });
  }

  function getConfig(instance) {
    return JSON.parse(instance.innerHTML);
  }

  function getTooltips(config) {
    return config.blocksId.map(getTooltip);
  }

  function getTooltip(id) {
    var host = document.getElementById("tooltip-" + id);
    return {
      id: id,
      trigger: host.querySelector("[data-tooltip-trigger]"),
      overlay: host.querySelector("[data-tooltip-overlay]"),
      markup: host.querySelector("[data-tooltip-markup]"),
      get collapsed() {
        return isCollapsed(this);
      },
    };
  }

  function tooltipClick(tooltips, id) {
    var isSelected = partial(idMatch, id);
    tooltips.filter(isSelected).map(toggle);
    tooltips.filter(not(isSelected)).filter(not(isCollapsed)).map(collapse);
  }

  function toggle(tooltip) {
    tooltip.collapsed ? expand(tooltip) : collapse(tooltip);
  }

  function expand(tooltip) {
    const backdrop = document.querySelector("[data-drawer-backdrop]");
    const content = tooltip.markup.innerHTML || tooltip.markup.textContent;

    // Inject content
    tooltip.overlay.innerHTML = `
      <div class="drawer-mobile-handle"></div>
      <button class="drawer-close-btn" aria-label="Close">&times;</button>
      <div class="drawer-content">
        ${content}
      </div>
    `;

    // Trigger Slide and Backdrop
    requestAnimationFrame(() => {
      tooltip.overlay.classList.add("is-active");
      if (backdrop) backdrop.classList.add("is-active");
    });

    document.body.style.overflow = "hidden";
    tooltip.trigger.setAttribute("aria-expanded", "true");

    // Close when clicking the backdrop
    if (backdrop) {
      backdrop.onclick = function () {
        collapse(tooltip);
      };
    }

    // Close button event
    const closeBtn = tooltip.overlay.querySelector(".drawer-close-btn");
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        collapse(tooltip);
      });
    }
  }

  function collapse(tooltip) {
    const backdrop = document.querySelector("[data-drawer-backdrop]");

    tooltip.overlay.classList.remove("is-active");
    if (backdrop) backdrop.classList.remove("is-active");

    document.body.style.overflow = "";
    tooltip.trigger.setAttribute("aria-expanded", "false");

    // Clean up
    setTimeout(() => {
      if (!tooltip.overlay.classList.contains("is-active")) {
        tooltip.overlay.innerHTML = "";
      }
    }, 400);
  }

  function animationReset(element, callback) {
    element.removeAttribute("style");
    element.removeEventListener("animationend", callback);
  }

  function idMatch(id, tooltip) {
    return tooltip.id === id;
  }

  function isCollapsed(tooltip) {
    return attr("aria-expanded", tooltip.trigger) === "false";
  }

  function height(tooltip) {
    return px(tooltip.overlay.offsetHeight.toString());
  }

  function px(n) {
    return n + "px";
  }

  /* DOM */
  function attr(str, element) {
    return element.getAttribute(str);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function pluck(array, key) {
    return array.map(function (obj) {
      return obj[key];
    });
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function () {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  /* Support */
  function getSupport() {
    return {
      customProperties: window.CSS && CSS.supports("color", "var(--primary)"),
    };
  }

  /* Theme editor */
  function select(blockId) {
    return expand(getTooltip(blockId));
  }

  function deselect(blockId) {
    return collapse(getTooltip(blockId));
  }
})((window.SectionsDesign = window.SectionsDesign || {}));
